import _root_default from "./_root.js";
import _getNative_default from "./_getNative.js";

//#region ../../node_modules/lodash-es/_WeakMap.js
var WeakMap = _getNative_default(_root_default, "WeakMap");
var _WeakMap_default = WeakMap;

//#endregion
export { _WeakMap_default as default };
//# sourceMappingURL=_WeakMap.js.map